// Components==============
import React from 'react';
import { TranslateType } from 'typings';
import './RichText.module.scss';
// =========================

export default function RichText({ content }: { content?: TranslateType }) {
  if (!content) return <></>;

  const mutatedContent = (content as string).replace(
    /<a /g,
    '<a target="_blank" rel="noreferrer" '
  );

  return (
    <div
      dangerouslySetInnerHTML={{ __html: mutatedContent as string }}
      styleName="wrapper"
    />
  );
}
